
import { defineComponent, onMounted, computed, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useContent } from "../../composables/useContent";
import LargePlayer from "../components/Player/LargePlayer.vue";
import RenderContent from "../components/RenderContent/RenderContent.vue";
import { getHeaderData } from "@/components/SEO/helpers";
import { useHead } from "@vueuse/head";
import { ZoomImg } from "vue3-zoomer";

export default defineComponent({
  name: "SegmentPage",
  components: {
    LargePlayer,
    ZoomImg,
    RenderContent,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const { load, result } = useContent();

    const segment = computed(() =>
      result.value?.id === "segment" ? result.value : undefined
    );

    const seo = computed(() => segment.value?.seo);
    const artist = computed(() => segment.value?.artist);
    const audio = computed(() => segment.value?.audio);

    const panels = computed(
      () => segment.value?.segmentContentCollection?.items
    );

    const headerData = computed(() =>
      getHeaderData(seo.value, { url: window.location.href })
    );

    // const showModal = ref(false);

    const showFullSize = ref(false);

    const isLoaded = ref(false);

    const setIsLoaded = () => {
      isLoaded.value = true;
    };

    const toggleShowFullSize = () => {
      showFullSize.value = !showFullSize.value;
    };

    onMounted(async () => {
      await load({ contentType: "segment", slug: route.params?.slug });
      if (result.value) {
        // If no data is returned other than the page id, page is not found so redirect to home
        Object.keys(result.value).length === 1
          ? router.push({ path: "/" })
          : null;
      }
    });

    useHead({
      title: computed(() => headerData.value?.title || "Art Mindfully"),
      meta: computed(() => headerData.value?.meta || []),
      link: computed(() => headerData.value?.link || []),
    });

    return {
      id: route.params.slug,
      segment,
      seo,
      artist,
      audio,
      route,
      headerData,
      // showModal,
      showFullSize,
      toggleShowFullSize,
      isLoaded,
      setIsLoaded,
      panels,
    };
  },
});
